import styled from "styled-components"
import { Tab } from "react-bootstrap"

const TabContentStyle = styled(Tab)`
    background-color: white!important;
`

export default TabContentStyle